<template>
  <div name="hrms12x-detail-send" id="hrms12x-detail-send">
    <div class="modal-header header-popup">
      <button type="button" class="close" data-dismiss="modal">&times;</button>
      <h4 class="modal-title">{{ labels['HRMS12X']['130'] }}</h4>
    </div>
    <div class="modal-body detail detail-responsive">
      <div class="detail detail-responsive">
        <div class="box-body">
          <div class="row">
            <div class="col-xs-12 col-md-2" />
            <div class="col-xs-12 col-md-8">
              <div class="form-group">
                <label>{{ labels['HRMS12X']['10'] }} <span class="red">*</span> :</label>
                <input  v-model="data.subject"
                        v-validate="'required'"
                        name="subject"
                        type="text" />
                <div class="text-error" v-show="errors.has('subject')">{{ errors.first('subject') }}</div>
              </div>
              <div class="form-group">
                <label>{{ labels['HRMS12X']['20'] }} <span class="red">*</span> :</label>
                <textarea v-model="data.msg"
                          v-validate="'required'"
                          name="msg"
                          type="text"
                          class="form-control"
                          rows="6" />
                <div class="text-error" v-show="errors.has('msg')">{{ errors.first('msg') }}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-2" />
            <div class="col-xs-12 col-md-8">
              <div class="form-group">
                <label>{{ labels['HRMS12X']['100'] }} :</label>
                <hrms-dropzone  v-model="fileName"
                                :triggerSuccess="triggerSuccess"
                                :flgRename="false"
                                ref="hrmsDropzone" />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 col-md-2" />
              <div class="form-group col-xs-12 col-md-4">
                <label>{{ labels['HRMS12X']['110'] }} :</label>
                <hrms-lov   v-model="data.codempid_sender"
                            :disabled="false"
                            :nowLang="nowLang"
                            lovType="codempid"
                            v-validate="'requiredWhenNotExist:codcomp'"
                            data-vv-value-path="inputValue"
                            data-vv-name="codempid"
                            name="codempid" />
                <div class="text-error" v-show="errors.has('codempid')">{{ errors.first('codempid') }}</div>
              </div>
              <div class="form-group col-xs-12 col-md-4">
                <label>{{ labels['HRMS12X']['120'] }} :</label>
                <hrms-lov-codcomp v-model="data.codcomp_sender"
                                  :nowLang="nowLang"
                                  v-validate="'requiredWhenNotExist:codempid'"
                                  data-vv-value-path="inputValue"
                                  data-vv-name="codcomp"
                                  name="codcomp" />
                <div class="text-error" v-show="errors.has('codcomp')">{{ errors.first('codcomp') }}</div>
              </div>
            </div>
          </div>
          <div class="box-footer padding-b-0">
            <button type="button" class="btn bg-color-skin" @click="callSendmail()" ><i class="fa fa-envelope"></i> {{ labelsButton['sendmail'] }}</button>
            <button type="button" class="btn bg-color-skin" data-dismiss="modal" @click="triggerCancelEvent" ref="popupSendMailModalButton"><i class="fa fa-times"></i> {{ labelsButton['cancel'] }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from 'src/../env.js'
import swal from 'sweetalert'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hrms12x-detail-send',
  props: [ 'labels', 'data', 'nowLang', 'labelsButton', 'postSendmail', 'currentUser', 'empmail', 'triggerIndexSelect', 'triggerSuccess', 'fileName', 'receiveClearDetail' ],
  watch: {
    'data.codempid_sender' () {
      this.$validator.validate('codempid', this.data.codempid_sender).catch(e => {})
    },
    'data.codcomp_sender' () {
      this.$validator.validate('codcomp', this.data.codcomp_sender).catch(e => {})
    },
    'data.subject' () {
      this.$validator.validate('subject', this.data.subject).catch(e => {})
    },
    'data.msg' () {
      this.$validator.validate('msg', this.data.msg).catch(e => {})
    },
    data () {
      this.$nextTick(function () {
        this.errors.clear()
      })
    }
  },
  methods: {
    saveParams () {
      return {
        p_subject: this.data.subject,
        p_msg: this.data.msg,
        p_attach: this.fileName ? window.localStorage.getItem(env.site + '_baseURL') + 'file_uploads/temp/' + this.fileName : '',
        p_codempid_sender: this.data.codempid_sender,
        p_codcomp_sender: this.data.codcomp_sender,
        p_reciver: this.empmail,
        referenceButton: this.$refs.popupSendMailModalButton,
        refCancelEvent: this.triggerCancelEvent
      }
    },
    callSendmail () {
      let _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          swal({
            title: constLabels('confirmTitle'),
            text: constLabels('msgConfirmEmail'),
            showCancelButton: true,
            closeOnConfirm: false,
            confirmButtonText: constLabels('ok'),
            cancelButtonText: constLabels('cancel'),
            html: true
          },
          function (isConfirm) {
            if (isConfirm) {
              _this.postSendmail(_this.saveParams())
            }
          })
        }
      })
    },
    triggerCancelEvent () {
      this.receiveClearDetail()
      this.$refs.hrmsDropzone.removeFileEvent()
    }
  }
}
</script>

<style lang="scss">

.sendmail-box {
  background: #FFF;
  box-shadow: 0 1px 1px 0 rgba(0,0,0,0.3);
  border-top: 1px solid #d2d6de;
}

</style>



// WEBPACK FOOTER //
// detailSend.vue?1b8c667e